import React from 'react'
import SubmitButton from '../../Form/SubmitButton/index'

const LinkButtonWithTextUnstyled = ({ label, ...otherProps }) => (
  <a {...otherProps}>
    <SubmitButton className={'buttonNext'}>{label}</SubmitButton>
  </a>
)

export default LinkButtonWithTextUnstyled
